<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<span class="d-none admin-layout">
  <div class="main-content-nav">

    <div>
      <span class="pull-left" style="color: white;">
        {{trainingData.trainingName}}
      </span>
    </div>
    <div class="userDetails">
      <div>
        <div class="col-sm-12 pull-right">
          <div class="username pull-right">
            {{userprofilename}}
            <button class="closeButton fa fa-close" (click)="closePreview()"></button>
          </div>
        </div>
      </div>
      <div>
      </div>
    </div>
  </div>
</span>

<div class="container">
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>

  <div class="d-flex">
    <div class="content_menu">
      <h5 class="training_text content_title fw-medium">
        {{ trainingData.trainingCode }}
      </h5>
      <h5 class="training_text content_title text-center my-3">
        Training Contents
      </h5>
      <div class="d-flex my-3 justify-content-between align-items-center">
        <div class="dropdown">
          <button class="btn training_text fw-medium all_dropdown border-0 outline-0 dropdown-toggle px-2" type="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            All

          </button>

        </div>
        <p class="progress_text training_text fw-medium">{{contentList.length}} Modules</p>
      </div>
      <div>
        <!-- active class is added -->
        <div class="mb-3 contents" *ngFor="let content of contentList,let i=index;"
          [class.active]="i+1 == clickedContent.contentSeq" (click)="openForPreview($event, content)"
          (keydown.enter)="openForPreview($event, content)">
          <div class="d-flex gap-2">
            <img *ngIf="content.status == 'Completed'" src="../../assets/img/cr_module/green_tick.svg" width="20px"
              height="20px" alt="check mark" />
            <img *ngIf="content.contentExtn =='mp4'" src="../../assets/img/training_module/video.svg" width="20px"
              height="20px" alt="video" />
            <img *ngIf="content.contentExtn =='mp3'" src="../../assets/img/training_module/audio.svg" width="20px"
              height="20px" alt="video" />
            <img *ngIf="content.contentExtn =='ppt' || content.contentExtn =='pptx'"
              src="../../assets/img/training_module/presentation.svg" width="20px" height="20px" alt="presentation" />
            <img *ngIf="content.contentExtn =='pdf'" src="../../assets/img/training_module/pdf.svg" width="20px"
              height="20px" alt="presentation" />
            <img *ngIf="content.contentExtn =='docx' || content.contentExtn =='xlsx'
            || content.contentExtn =='txt' || content.contentExtn =='TXT'"
              src="../../assets/img/training_module/Tab - Files.svg" width="20px" height="20px" alt="presentation" />
            <img *ngIf="content.contentExtn ==null" src="../../assets/img/training_module/Test.svg" width="20px"
              height="20px" alt="presentation" />
            <p class="training_text">
              <span class="fw-medium" *ngIf="content.contentExtn =='mp4'">Video: </span>
              <span class="fw-medium" *ngIf="content.contentExtn =='mp3'">Audio: </span>
              <span class="fw-medium" *ngIf="content.contentExtn =='pdf' || content.contentExtn =='docx' || content.contentExtn =='xlsx'
              || content.contentExtn =='txt' || content.contentExtn =='TXT'">Text: </span>
              <span class="fw-medium" *ngIf="content.contentExtn =='ppt' || content.contentExtn =='pptx'">Presentation:
              </span>
              {{content.contentName}}
            </p>
          </div>
          <p class="training_text duration mt-1">{{content.totalDuration}}</p>
        </div>

      </div>
    </div>
    <div class="right_container">
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="training_text content_title fw-medium">
          {{ trainingData.trainingName }}
        </h5>
        <div class="d-flex navbar_shadow p-2">
          <div class="notification_bg rounded-3 position-relative p-1" style="margin-top: 5px;cursor: pointer;"
            (click)="openNotifications()" (keydown.enter)="openNotifications()">
            <svg width="28" height="28" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path _ngcontent-ng-c2569100152=""
                d="M3.14999 4.9501L8.4877 8.64544C8.7959 8.85881 9.20408 8.85881 9.51228 8.64544L14.85 4.9501M3.59999 14.4001H14.4C15.3941 14.4001 16.2 13.5942 16.2 12.6001V5.4001C16.2 4.40599 15.3941 3.6001 14.4 3.6001H3.59999C2.60588 3.6001 1.79999 4.40599 1.79999 5.4001V12.6001C1.79999 13.5942 2.60588 14.4001 3.59999 14.4001Z"
                stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <span class="badge_position p-1 bg-danger border-0 rounded-circle">
              <span class="visually-hidden">New alerts</span>
            </span>
          </div>
          <div class="d-flex px-2">
            <div class="me-2">
              <span *ngIf="oneQmsOrgUsersDetails == null || oneQmsOrgUsersDetails == undefined">
                <i class="fa-regular fa-circle-user userimg" style="font-size: 33px;"></i>
              </span>
              <span *ngIf="oneQmsOrgUsersDetails != null || oneQmsOrgUsersDetails != undefined">
                <img alt="userimg" class="userimg" src="data:image/*;base64,{{oneQmsOrgUsersDetails.userImage}}"
                  width="45" height="40">
              </span>
            </div>
            <div class="dropdown">
              <button *ngIf="userprofilename!=null&&userprofilename!=undefined"
                class="btn border-0 outline-0 dropdown-toggle px-1" type="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                {{userprofilename}}
              </button>

            </div>
            <div class="d-flex justify-content-center align-items-center actions_cta cancel_cta"
              (click)="closePreview()" (keydown.enter)="closePreview()">
              <img src="../../assets/img/cr_module/cancel.svg" width="9px" height="9px" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <div>
          <div class="" *ngIf="
              clickedContent.contentExtn == 'TXT' ||
              clickedContent.contentExtn == 'txt'
            ">
            <div class="">
              <iframe title="iframe" id="myIframe" src="" height="604px" width="100%"
                style="overflow: hidden; height: 604px; width: 100%"></iframe>
            </div>
          </div>
          <div class="" *ngIf="
              clickedContent.contentExtn == 'pdf' ||
              clickedContent.contentExtn == 'docx' ||
              clickedContent.contentExtn == 'xlsx' ||
              clickedContent.contentExtn == 'ppt' ||
              clickedContent.contentExtn == 'pptx'
            ">
            <div style="height: 604px">
              <web-viewer [data]="viewerData" (oneQmsListener)="onUserActivity()"></web-viewer>
            </div>
            <div>
              <div class="mt-2">
                <span class="progress_text training_text text-black fw-semibold">Overview</span>
                <div class="overview_underline">
                  <span class="overview_highlight"></span>
                </div>
              </div>
              <div>
                <h3 class="intro_text mt-4 mb-3">
                  {{clickedContent.contentName}}
                </h3>
                <p class="training_text all_dropdown lh-base">
                  {{clickedContent.contentDescription}}
                </p>
              </div>
            </div>
          </div>
          <div class="" *ngIf="clickedContent.contentExtn == 'mp4'">
            <div class="">
              <video autoplay id="videoarea" controls="controls" controlsList="nodownload" poster=""
                style="height: 604px; width: 100%;">
                <source src="">

                <track kind="subtitles" src="assets/i18n/subtitles_en.vtt" srclang="en" label="English Subtitles">

                <track kind="descriptions" src="assets/i18n/descriptions_en.vtt" srclang="en"
                  label="English Descriptions">
              </video>
            </div>
            <div>
              <div class="mt-2">
                <span class="progress_text training_text text-black fw-semibold">Overview</span>
                <div class="overview_underline">
                  <span class="overview_highlight"></span>
                </div>
              </div>
              <div>
                <h3 class="intro_text mt-4 mb-3">
                  {{clickedContent.contentName}}
                </h3>
                <p class="training_text all_dropdown lh-base">
                  {{clickedContent.contentDescription}}
                </p>
              </div>
            </div>
          </div>
          <div class="" *ngIf="clickedContent.contentExtn == 'mp3'">
            <div>
              <div class="audio_bg">
                <img src="../../assets/img/training_module/audio_bg.png" width="100%" height="604px"
                  alt="audio background " />
              </div>
              <div class="loader">
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
                <span class="stroke"></span>
              </div>
              <div class="audio_file">
                <audio controls id="audio">
                  <source src="" />
                </audio>
              </div>
            </div>
            <div>
              <div class="mt-2">
                <span class="progress_text training_text text-black fw-semibold">Overview</span>
                <div class="overview_underline">
                  <span class="overview_highlight"></span>
                </div>
              </div>
              <div>
                <h3 class="intro_text mt-4 mb-3">
                  {{clickedContent.contentName}}
                </h3>
                <p class="training_text all_dropdown lh-base">
                  {{clickedContent.contentDescription}}
                </p>
              </div>
            </div>
          </div>
          <div class="row" style="padding: 5px" *ngIf="
              clickedContent.contentExtn == 'png' ||
              clickedContent.contentExtn == 'jpeg' ||
              clickedContent.contentExtn == 'PNG' ||
              clickedContent.contentExtn == 'JPEG' ||
              clickedContent.contentExtn == 'JPG' ||
              clickedContent.contentExtn == 'jpg'
            ">
            <div class="col-sm-12">
              <img alt="img" id="picture" src="" height="85vh" width="100%" style="overflow: hidden; height: 85vh; width: 100%" />
            </div>
          </div>
          <div class="row" *ngIf="content.isQuestionContent == 'Y'" id="container" class="item-border">


            <div>
              <div class="d-flex gap-5">
                <div style="flex: 2">
                  <div class="">
                    <div class="" *ngFor="let question of content['questionsList']; let i = index">
                      <div class="question_container">
                        <div class="questions">
                          <span class="question_number fw-medium">
                            Q. {{ i + 1 }}/{{ content['questionsList'].length }}
                          </span>
                        </div>
                        <p class="question_number ps-4 py-2">
                          {{ question.question }}
                        </p>
                        <div class="ps-4 pb-2 imgPopup" *ngIf="question.questionImage != null">
                          <img alt="qts" src="data:image/png;base64,{{
                              question.questionImage
                            }}" style="width: 300px; height: 300px" />
                        </div>
                      </div>
                      <div class="options">

                        <div class="" style="margin-top: 2%">
                          <div class="">

                            <div class="table-borderless" style="overflow-x: hidden">
                              <div *ngFor="let option of question['optionsList']; let i = index">
                                <div *ngIf="
                            question?.questionType == 'Radio Button' ||
                            question?.questionType == 'RADIO'
                          " class="options_block">

                                  <div class="ps-4 py-2">
                                    <mat-radio-button class="tp-radio-button" [name]="'Radio'"
                                      [value]="option?.optionCode" [checked]="option.checked">
                                      <span class="text-black fw-normal">{{ option.optionCode }}. {{
                                        option.optionValue
                                        }}</span>
                                    </mat-radio-button>
                                  </div>
                                </div>
                                <div *ngIf="
                            question?.questionType == 'Check Box' ||
                            question?.questionType == 'CHECKBOX'
                          " class="options_block">
                                  <div class="ps-4 py-2">
                                    <mat-checkbox [name]="option?.optionCode" [checked]="option.checked"
                                      [value]="option?.optionCode">
                                      <span class="text-black fw-normal">{{ option.optionCode }}. {{
                                        option.optionValue
                                        }}</span></mat-checkbox>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div class="options_block1">
                        <div class="ps-4 py-2">
                          Answer : {{question.answer}}
                        </div>
                      </div>

                      <hr />

                    </div>

                  </div>

                </div>


              </div>

              <br />
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #notificationPopup>
  <button class="close close-button" (click)="cancelNotificationPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Notifications</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="myTrainingLeftPlace" style="height: auto;max-height: 600px;overflow-y: auto;overflow-x: hidden;">
    <app-activity-notifications></app-activity-notifications>
  </div>
</ng-template>